const lang = {
  en: {
    Search: "Search",
    gptSearchPlaceholder: "What would you like to watch today?",
  },
  hindi: {
    Search: "खोजें",
    gptSearchPlaceholder: "आज क्या देखना चाहते हैं?",
  },
  spanish: {
    Search: "Buscar",
    gptSearchPlaceholder: "¿Qué quieres ver hoy?",
  },
};
export default lang;
